<template>
  <div style="padding-top:400px">
    <section>
      <div v-if="this.isInMaintenance === true">
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <h2>Le site est en maintenance pour la journée, la connexion est impossible...</h2>
          </div>
        </div>
      </div>
      <transition v-if="this.isInMaintenance === false" name="fade" mode="out-in">
        <div>
          <div v-if="page === 'login'" key="1">
            <div class="columns">
              <div class="column is-half is-offset-one-quarter">
                <b-field label="Code Client" type="is-success" message="">
                  <b-input v-model="user.code" maxlength="30"></b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column is-half is-offset-one-quarter">
                <b-field label="Mot de passe" class="is-size-2">
                  <b-input type="password" v-model="user.password" password-reveal>
                  </b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column is-offset-one-quarter">
                <div class="buttons">
                  <b-button type="is-success" @click="login">Entrer</b-button>
                  <b-button type="is-warning" @dblclick="isInMaintenance=false">Quitter</b-button>
                </div>
              </div>
              <div class="column">
                <a href="#" v-on:click="page = 'startRenewPassword'"> Mot de passe oublié ?</a>
                <span> v 11.07</span>
              </div>
            </div>
          </div>
          <!-------------------Envoi mail lien unique ----------------->
          <ValidationObserver>
            <div v-if="page === 'startRenewPassword'" key="2">
              <!---STEP 1-->
              <div v-if="stepRenewPassword === 1">
                <div class="row">
                  <div class="column is-offset-one-quarter is-one-quarter">
                    <p>Saisissez votre code client et votre mail.</p>
                  </div>
                </div>
                <div class="columns">
                    <div class="column is-half is-offset-one-quarter">
                    <ValidationProvider rules="required" name="Code" v-slot="{ valid, errors }">
                      <b-field label="Code Client" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                      <b-input v-model="user.code" maxlength="30"></b-input>
                    </b-field>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-offset-one-quarter is-one-quarter">
                    <ValidationProvider rules="email" name="Date" v-slot="{ valid, errors }">
                      <b-field label="Email" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                        <b-input type="email" v-model="user.email" value="" maxlength="50">
                        </b-input>
                      </b-field>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-offset-one-quarter is-one-quarter">
                    <div class="buttons">
                      <b-button type="is-success" @click="renewPasswordSendCode">Envoyer</b-button>
                    </div>
                  </div>
                  <div class="column">
                    <div class="column">
                      <b-button type="is-danger" v-on:click="page = 'login'"> Annuler</b-button>
                    </div>
                  </div>
                </div>
              </div>
            <!--STEP 2 CHECK CODE-->
            <div v-if="stepRenewPassword === 2">
              <div class="row">
                <div class="column is-offset-one-quarter is-one-quarter">
                  <p>Saisissez le code reçu par mail et validez.</p>
                </div>
              </div>
              <div class="columns">
                <div class="column is-offset-one-quarter is-one-quarter">
                  <b-field label="Code">
                    <b-input type="text" v-model="user.renewCode" value="" maxlength="6">
                    </b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column is-offset-one-quarter is-one-quarter">
                  <div class="buttons">
                    <b-button type="is-success" @click="renewPasswordCheckCode">Valider</b-button>
                  </div>
                </div>
                <div class="column">
                  <b-button type="is-danger" v-on:click="page = 'login'"> Annuler</b-button>
                </div>
            </div>
        </div>
  </div>
  </ValidationObserver>
  <!------------------Renew Password ------------------------->
  <div v-if="page === 'renewPassword'" key="3">
    <div class="columns">
      <div class="column is-offset-one-quarter is-one-quarter">
        Saisissez votre nouveau mot de passe ici
      </div>
    </div>
    <div class="columns">
      <div class="column is-offset-one-quarter is-one-quarter">
        <b-field label="Nouveau mot de passe">
          <b-input type="password" value="" maxlength="30" v-model="user.newPassword" password-reveal>
          </b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column is-offset-one-quarter is-one-quarter">
        <b-field label="Confirmation">
          <b-input type="password" value="" maxlength="30" v-model="user.newPasswordConfirmation" password-reveal>
          </b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column is-offset-one-quarter is-one-quarter">
        <div class="buttons">
          <b-button type="is-success" @click="renewPasswordSendPassword">Envoyer</b-button>
        </div>
      </div>
    </div>
  </div>
  </div>
  </transition>
  <div class="columns">
    <div class="column is-offset-one-quarter is-one-quarter">
      <WakaNotification :notification="notification" />
    </div>
  </div>
  </section>
  </div>
</template>
<script>
import {
  httpPost, httpGet
} from '../wakasoft.js'
import WakaNotification from '@/components/WakaNotification.vue'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
extend('email', {
  ...email,
  message: 'le mail est invalide'
})
extend('required', {
  ...required,
  message: 'Ce champ est obligatoire'
})
extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Les mots de passe ne sont pas identiques'
})
export default {
  name: 'AuthentificationLogin',
  components: {
    WakaNotification, ValidationObserver, ValidationProvider
  },
  data () {
    return {
      showDismissibleAlert: 0,
      isReady: false,
      user: {
        code: '',
        password: '',
        email: ''
      },
      message: '',
      fullscreen: false,
      page: 'login',
      stepRenewPassword: 1,
      isInMaintenance: false,
      notification: {
        message: '',
        isActive: false,
        isSuccess: false
      }
    }
  },
  methods: {
    async renewPasswordSendPassword () {
      if (this.isInMaintenance) {
        return
      }
      try {
        if (this.user.newPassword !== this.user.newPasswordConfirmation) {
          this.notification = {
            message: 'les deux mots de passe ne sont pas identiques !',
            isSuccesss: false,
            isActive: true
          }
        } else {
          var url = this.$store.state.API_BASE_URL + '/login/renew-password'
          var body = JSON.stringify(this.user)
          await httpPost(url, body)
          this.stepRenewPassword = 2
          this.notification = {
            message: 'votre mot de passe a été modifié',
            isSuccess: true,
            isActive: true
          }
          this.page = 'login'
        }
      } catch (err) {
        this.notification = {
          message: err.message,
          isSuccess: false,
          isActive: true
        }
      }
    },
    async renewPasswordSendCode () {
      if (this.isInMaintenance) {
        return
      }
      try {
        var url = this.$store.state.API_BASE_URL + '/login/send-code'
        var body = JSON.stringify(this.user)
        await httpPost(url, body)
        this.stepRenewPassword = 2
      } catch (err) {
        this.notification = {
          message: err.message,
          isSuccesss: false,
          isActive: true
        }
      }
    },
    async renewPasswordCheckCode () {
      try {
        var url = this.$store.state.API_BASE_URL + '/login/check-code'
        var body = JSON.stringify(this.user)
        var json = await httpPost(url, body)
        console.log(json)
        this.stepRenewPassword = 1
        this.page = 'renewPassword'
      } catch (err) {
        this.notification = {
          message: err.message,
          isSuccesss: false,
          isActive: true
        }
      }
    },
    async login () {
      if (this.isInMaintenance && this.user.code !== 'CNPTEST') {
        return
      }
      try {
        var url = this.$store.state.API_BASE_URL + '/login/authenticate'
        var body = JSON.stringify(this.user)
        this.user = await httpPost(url, body)
        console.log(this.user)
        console.log('status' + this.user.status)
        if (this.user.status === 'Attente connexion') {
          this.user.password = ''
          this.newPassword = ''
          this.page = 'renewPassword'
        } else {
          await this.$store.dispatch('setCurrentUser', this.user)
          window.localStorage.sessionUser = this.user.code
          window.localStorage.sessionToken = this.user.token
          window.localStorage.sessionExpiry = this.user.expiry
          this.$router.push('/customer-dashboard')
        }
      } catch (response) {
        console.log(response)
        if (response.status === 401) {
          this.notification = {
            message: 'Authentification refusée',
            isSuccesss: false,
            isActive: true
          }
        } else {
          this.notification = {
            message: response.status + '-' + response.statusText,
            isSuccesss: false,
            isActive: true
          }
        }
      }
    },
    cancel () {
      this.login = {
        code: '',
        password: '',
        email: ''
      }
    }
  },
  async mounted () {
    try {
      var url = this.$store.state.API_BASE_URL + '/login/isInMaintenance'
      this.isInMaintenance = Boolean(await httpGet(url, 'GET', []))
      console.log('maintenance : ' + this.isInMaintenance)
      this.isReady = true
    } catch (err) {
      this.message = err
      this.showDismissibleAlert = 4
    }
  }
}
</script>
